export const CONTACTS = {
  WHATSAPP: {
    number: '554792923530',
    url: 'https://wa.me/554792923530',
  },
  EMAIL: 'staaff.plus@gmail.com',
  INSTAGRAM: 'https://www.instagram.com/staffplus_rh/',
  LINKEDIN_DEV: 'https://www.linkedin.com/in/htferretti/',
} as const;

export const COMPANY_NAME = 'StaffPlus RH';
export const COMPANY_YEAR = 2025;
